import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Empty_Nav_Interface, Nav_Interface } from 'src/app/Interface/Nav_Interface';
import { Empty_User_Interface, User_Interface } from 'src/app/Interface/User_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { DeviceBehfaService } from 'src/app/Service/DeviceBehfa/DeviceBehfa.service';
import { LetterRequestCustomerService } from 'src/app/Service/Letter/LetterRequestCustomer.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { TicketCategoryService } from 'src/app/Service/TicketCategory/TicketCategory.service';
import { UserService } from 'src/app/Service/User/User.service';

@Component({
  selector: 'app-UserEdit',
  templateUrl: './UserEdit.component.html',
  styleUrls: ['./UserEdit.component.scss']
})
export class UserEditComponent implements OnInit {
  FullName: String = ""
  EditRecord: number

  constructor(
    private User_Service: UserService,
    private Alertify_Service: AlertifyService,
    private Nav_Service: NavService,
    private route: ActivatedRoute
  ) { }
  ngOnInit() {
    this.EditUser = new FormGroup({
      id: new FormControl(),
      Password: new FormControl(null, [Validators.minLength(6)]),
      Type: new FormControl("0"),
      ExpertCalibration: new FormControl("0"),
    })

    this.EditRecord = Number(this.route.snapshot.paramMap.get('id'))


    this.Nav_Service.CheckValidPage(22).subscribe(
      data => {


        this.User_Service.GetSingle(this.EditRecord).subscribe(
          data => {
            this.FullName = data.familly
            this.get_Form_Id().setValue(data.id)
            this.get_Form_Type().setValue(data.type + "")

            if (data.expert_calibration) {
              this.get_Form_ExpertCalibration().setValue("1")
            }
            else {
              this.get_Form_ExpertCalibration().setValue("0")
            }


          }, error => {
            // AuthInterceptor owns authentication; feature errors must preserve credentials.

          }
        )


      }
      , error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )


  }



  //#region  Form Add

  EditUser: FormGroup;

  get_Form_Id() {
    return this.EditUser.get('id') as FormControl;
  }

  get_Form_Password() {
    return this.EditUser.get('Password') as FormControl;
  }

  get_Form_Type() {
    return this.EditUser.get('Type') as FormControl;
  }

  get_Form_ExpertCalibration() {
    return this.EditUser.get('ExpertCalibration') as FormControl;
  }

  //#endregion

  InProccessing: boolean = false

  SubmitEditUser() {
    if (Number(this.get_Form_Type().value) == 0) {
      this.Alertify_Service.ErrorMessage("نوع کاربر را انتخاب کنید")
    }
    else {
      var Record: User_Interface = Empty_User_Interface()
      Record.id = Number(this.get_Form_Id().value)
      Record.password = this.get_Form_Password().value
      Record.type = Number(this.get_Form_Type().value)
      Record.expert_calibration = (Number(this.get_Form_ExpertCalibration().value) == 1)


      this.InProccessing = true
      this.User_Service.EditUser(Record,
        [],
        [],
        [],
        [],
        []).subscribe(
          data => {
            this.InProccessing = false
            if (data.id == -2) {
              this.Alertify_Service.ErrorMessage("نام کاربری وارد شده ، در لیست وجود دارد")
            }
            else {
              this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")
            }
          }
        )

    }

  }


}
